import React, { Component } from "react";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "../TransferenciaQrEnviar/TransferenciaQrEnviarPaso1";
import Paso2 from "../TransferenciaQrEnviar/TransferenciaQrEnviarPaso2";
import Paso3 from "../TransferenciaQrEnviar/TransferenciaQrEnviarPaso3";
import Paso4 from "../TransferenciaQrEnviar/TransferenciaQrEnviarPaso4";

export default class TransferenciaQrEnviar extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentaOrigen: {},
    datosTransfQR: {},
    importe: 0,
    nroOperacion: 0,
  });
  returnDataPaso1( _datosTransfQR) {
    this.setState({
      datosTransfQR: _datosTransfQR,
    });
  }
  returnDataPaso2(_importe, _motivo, _cuentaOrigen) {
    this.setState({
      importe: _importe,
      motivo: _motivo,
      cuentaOrigen: _cuentaOrigen,
    });
  }
  returnDataPaso3(_nroOperacion, _importe) {
    this.setState({
      nroOperacion: _nroOperacion,
      importe: _importe
    });
  }
  returnDataPaso4() {
    this.setState(this.getInitialState());
  }


  onStepChange = (stats) => {  
    if (stats.previousStep === 2) {      
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Transferir por QR" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{zIndex: 0}}>
                    <StepWizard
                      isLazyMount={true}
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        datosTransfQR={this.state.datosTransfQR}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        cuentaOrigen={this.state.cuentaOrigen}
                        datosTransfQR={this.state.datosTransfQR}
                        motivo={this.state.motivo}
                        importe={this.state.importe}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}
                        importe={this.state.importe}
                        nroOperacion={this.state.nroOperacion}
                        cuentaOrigen={this.state.cuentaOrigen}
                        datosTransfQR={this.state.datosTransfQR}
                        motivo={this.state.motivo}
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
